import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { showTextOverlay } from '../../../actions/textoverlay';
import Icon from '../../atoms/Icon';

var AppConfig = require('../../../config.json');

const getAGBLink = payment => 
	{
		switch(payment) {
			case 'sf':
			return AppConfig.legalCheckboxLinks.agbsf;
			case 'sk':
			case 'pc':
			return AppConfig.legalCheckboxLinks.agbsk;
			case 'mk':
			return AppConfig.legalCheckboxLinks.agbmk;
			case 'mke':
			return AppConfig.legalCheckboxLinks.agbmke;
			case 'std':
			default:
			return AppConfig.legalCheckboxLinks.agb;
		}
	}

const getWiderrufLink = payment => 
	{
		switch(payment) {
			case 'sf':
			return AppConfig.legalCheckboxLinks.widerrufsf;
			case 'sk':
			case 'pc':
			return AppConfig.legalCheckboxLinks.widerrufsk;
			case 'mk':
			return AppConfig.legalCheckboxLinks.widerrufmk;
			case 'mke':
			return AppConfig.legalCheckboxLinks.widerrufmke;
			case 'std':
			default:
			return AppConfig.legalCheckboxLinks.widerruf;
		}
	}


/**
 * A simple OrderFormLegalCheckbox.
 */

class OrderFormLegalCheckbox extends React.Component {
	constructor(props) {
	  super(props);
	  this.showInfo = this.showInfo.bind(this);
		this.handleClick = this.handleClick.bind(this);
	  this.state = {active:false, init:false};
	}
	componentDidMount() {
		if(this.props.checkout.checkbox) {
			this.setState({active:true});
		}
		this.setState({init:true});
	}


	handleClick(e) {
		var nextState = !this.state.active;
		this.setState({active:!this.state.active});
		this.props.onClick(nextState);
	}

	showInfo(e) {
		e.preventDefault();
		var type = this.props.insurance.type;
      this.props.dispatch(showTextOverlay({text:AppConfig.insuranceoverlay[type].text,headline:AppConfig.insuranceoverlay[type].headline,downloadStr:"» Laden Sie hier die Bedingungen als PDF herunter."}));
    }


    render () {
        return (
          <div className={`orderformlegalcheckbox${this.state.active?" selected":""}`}>
            <div className="toggler">
            	<div className="toggleselect" onClick={this.handleClick}><Icon filename="selected" /></div>
            </div>
            <div className="inner">
            	<div className="desc" onClick={this.handleClick}>
	            	<div className="subline bold" style={{color:"black"}}>
	              		Ich habe die <span><a href={getAGBLink(this.props.payment)} target="_blank" rel="noopener noreferrer">AGB</a> </span>
	              		sowie die <span><a href={getWiderrufLink(this.props.payment)} target="_blank" rel="noopener noreferrer">Widerrufsbelehrung</a> der GfdB mbH </span>
	              		{this.props.insurance.active && <span> sowie die <a href={AppConfig.legalCheckboxLinks.versicherung} target="_blank" rel="noopener noreferrer">SchoolProtect Bedingungen</a> </span> }
	              		gelesen und erkläre mich mit diesen einverstanden.<br/>
						  Wir verwenden Ihre Daten zur Abwicklung Ihrer Bestellung. Außerdem für E-Mails mit Informationen zu ähnlichen Waren oder Dienstleistungen.
	              	</div>
            	</div>
            </div>
            
          </div>
        );
    }

}

OrderFormLegalCheckbox.propTypes = {
	/** Gets called when the user clicks on the item */
	onClick: PropTypes.func,
	payment:PropTypes.string,
	insurance: PropTypes.object
}

OrderFormLegalCheckbox.defaultProps = {
	/* eslint-disable no-console */
	onClick: event => {
		console.log('You have clicked a OrderFormLegalCheckbox Component!', event.target);
	},
	payment: "std",
	insurance: {"active":false, "type":"std"}
	
}


const mapStateToProps = (state) => {
  return {
    checkout: state.status.checkout
  }
}
const mapDispatchToProps = dispatch => {
  return {
    dispatch: dispatch
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OrderFormLegalCheckbox)







// WEBPACK FOOTER //
// ./src/components/molecules/OrderFormLegalCheckbox/OrderFormLegalCheckbox.js